<template>
    <div class="float-left mr-1" v-if="convenio.idSituacaoConvenio != 9">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Aporte Parceiro"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <aporte-parceiro-form
            operacaoProp="A"
            :convenio="convenio"
            :aporteParceiro="aporteParceiro"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></aporte-parceiro-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AporteParceiroForm from './AporteParceiroForm.vue'

export default {
    components: {
        AporteParceiroForm
    },

    props: {
        convenio: Object,
        aporteParceiro: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(aporteParceiro) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.alterarAporteParceiro(aporteParceiro).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Aporte atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
